import { render, staticRenderFns } from "./TestModule.vue?vue&type=template&id=1c96a87d"
import script from "./TestModule.vue?vue&type=script&lang=js"
export * from "./TestModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports